import { MessageDescriptor } from 'react-intl';

import { createReducer } from 'typesafe-actions';

import { showMessage } from '../actions';
import { SnackbarContentWrapperVariantKey } from '../core/Snackbar/SnackbarContentWrapper';

export interface MessageStore {
  timestamp: number;
  message: string | { messageIntl: MessageDescriptor };
  variant: SnackbarContentWrapperVariantKey;
}

const initialState = {} as MessageStore;

const createMessageReducer = () =>
  createReducer(initialState).handleAction(showMessage, (_, action) => ({
    timestamp: new Date().getTime(),
    message: action.payload,
    variant: action.meta,
  }));

export default createMessageReducer;
